module.exports = __webpack_public_path__ + "static/media/utm_avoitalic.6cb50097.woff";


//////////////////
// WEBPACK FOOTER
// ./src/static/Assets/Fonts/utm_avoitalic.woff
// module id = 377
// module chunks = 7